import React from "react";
import { BASE_API_URL } from "../constants";

const MaintenancePage = () => {
    const currentYear = new Date().getFullYear();

    return (
        <div
            style={{
                margin: 0,
                padding: 25,
                fontFamily: "'Poppins', sans-serif",
                backgroundColor: "#f5f9ff",
                color: "#1a1a1a",
                display: "flex",
                flexDirection: "column",
                justifyContent: "center",
                alignItems: "center",
                height: "100vh",
                textAlign: "center",
            }}
        >
            <div
                style={{
                    maxWidth: 600,
                    background: "#ffffff",
                    padding: 40,
                    borderRadius: 16,
                    boxShadow: "0 6px 16px rgba(0, 0, 0, 0.1)",
                }}
            >
                <img
                    src={BASE_API_URL + "web/static/media/wp/Fintoologo_.svg"}
                    alt="Fintoo Logo"
                    style={{ width: 140, marginBottom: 20 }}
                />
                <h1 style={{ fontSize: 28, color: "#042b62", marginBottom: 12 }}>
                    We’re upgrading!
                </h1>
                <p style={{ fontSize: 16, lineHeight: 1.6, color: "#444", marginBottom: 8 }}>
                    Our site is currently under scheduled maintenance as we work on migrating to a
                    new and improved platform.
                </p>
                <p style={{ fontSize: 16, lineHeight: 1.6, color: "#444", marginBottom: 8 }}>
                    We’ll be back shortly — better, faster, and smarter!
                </p>
                <p style={{ fontSize: 16, lineHeight: 1.6, color: "#444", marginBottom: 8 }}>
                    Thank you for your patience and continued support.
                </p>
                <div style={{ marginTop: 25, fontSize: 13, color: "#888" }}>
                    © {currentYear} Fintoo. All rights reserved.
                </div>
            </div>
        </div>
    );
};

export default MaintenancePage;